import { render, staticRenderFns } from "./impact-performance.vue?vue&type=template&id=6ed04c18"
import script from "./impact-performance.ts?vue&type=script&lang=ts&external"
export * from "./impact-performance.ts?vue&type=script&lang=ts&external"
import style0 from "./impact-performance.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports